import { RouteConfig } from "vue-router"

/**
 * RouteConfigを定義します: [OperatorRoleList]。
 */
export const OperatorRoleListRouteConfig: RouteConfig = {
  path: "/OperatorRoleList",
  name: "OperatorRoleList",
  component: () => import("%%/views/operatorRoleList/OperatorRoleList.vue"),
  meta: {
    reload: false,
    authRequired: true,
  },
}
